import { createPinia } from 'pinia'
import { Router, useRouter } from 'vue-router'
import { App, Plugin } from 'vue'
import { ToastType, useToast } from '@/shared/composables/UseToast'
import { useQueryClient } from '@tanstack/vue-query'

declare module 'pinia' {
  export interface PiniaCustomProperties {
    router: Router
    toast: ToastType
    queryClient: ReturnType<typeof useQueryClient>
  }
}

const pinia = createPinia()

pinia.use(({ store }) => {
  store.router = useRouter()
  store.queryClient = useQueryClient()
  store.toast = useToast()
})

export default {
  install(app: App) {
    app.use(pinia)
  },
} as Plugin
